import logo from "@/assets/postflow-logo.png";
import { Link } from "react-router-dom";

const EMAIL = "contato@ctr2sr.com.br";
const UPDATED = "Junho de 2026";

export default function Termos() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-800" data-testid="terms-page">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-6 py-4">
          <img src={logo} alt="PostFlow AI" className="h-9 w-9 rounded-lg" />
          <div>
            <div className="font-display text-lg font-extrabold text-slate-900">PostFlow AI</div>
            <div className="text-xs text-slate-500">Termos de Serviço</div>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-10">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-slate-900">Termos de Serviço</h1>
        <p className="mt-2 text-sm text-slate-500">Última atualização: {UPDATED}</p>

        <section className="prose prose-slate mt-8 max-w-none text-sm leading-relaxed [&_h2]:mt-8 [&_h2]:text-lg [&_h2]:font-bold [&_h2]:text-slate-900 [&_p]:mt-3 [&_ul]:mt-3 [&_ul]:list-disc [&_ul]:pl-6 [&_li]:mt-1">
          <p>
            Bem-vindo à PostFlow AI ("plataforma"), operada por CTR2. Ao criar uma conta ou utilizar nossos serviços,
            você concorda com estes Termos de Serviço. Leia-os com atenção.
          </p>

          <h2>1. Descrição do serviço</h2>
          <p>
            A PostFlow AI é uma plataforma de planejamento, geração e publicação de conteúdo para redes sociais, com
            recursos de inteligência artificial (texto, imagem e vídeo) e integrações oficiais com Instagram, Facebook,
            Google Meu Negócio, YouTube e TikTok, entre outros.
          </p>

          <h2>2. Cadastro e conta</h2>
          <ul>
            <li>Você é responsável por manter a confidencialidade das suas credenciais de acesso.</li>
            <li>As informações fornecidas devem ser verdadeiras, precisas e atualizadas.</li>
            <li>Você é responsável por todas as atividades realizadas na sua conta.</li>
          </ul>

          <h2>3. Uso das integrações com redes sociais</h2>
          <p>
            Ao conectar suas contas (Meta, Google, YouTube, TikTok), você autoriza a PostFlow AI a publicar e gerenciar
            exclusivamente o conteúdo que você criar ou aprovar. Os tokens de acesso são usados apenas para essa
            finalidade e podem ser revogados a qualquer momento. O uso das APIs de terceiros segue as respectivas
            políticas de cada plataforma (Meta Platform Policy, YouTube API Services Terms, TikTok Developer Terms).
          </p>

          <h2>4. Conteúdo gerado por IA</h2>
          <p>
            Os conteúdos gerados por IA são sugestões. Você é o único responsável por revisar, aprovar e publicar o
            material, garantindo que esteja em conformidade com as leis aplicáveis e com as diretrizes de cada rede
            social. A PostFlow AI não se responsabiliza por conteúdo publicado por você.
          </p>

          <h2>5. Uso aceitável</h2>
          <ul>
            <li>É proibido usar a plataforma para conteúdo ilegal, ofensivo, enganoso ou que viole direitos de terceiros.</li>
            <li>É proibido tentar burlar limites técnicos, de segurança ou de uso das APIs integradas.</li>
            <li>Reservamo-nos o direito de suspender contas que violem estes termos.</li>
          </ul>

          <h2>6. Propriedade intelectual</h2>
          <p>
            A plataforma, sua marca e seu código são de propriedade da CTR2. O conteúdo que você cadastra e cria
            permanece de sua propriedade.
          </p>

          <h2>7. Planos e pagamentos</h2>
          <p>
            Eventuais planos, limites e cobranças serão informados na plataforma. Recursos de IA podem estar sujeitos a
            limites de uso.
          </p>

          <h2>8. Limitação de responsabilidade</h2>
          <p>
            A plataforma é fornecida "como está". Não garantimos disponibilidade ininterrupta nem resultados específicos
            de alcance/engajamento. Na máxima extensão permitida por lei, não nos responsabilizamos por danos indiretos
            decorrentes do uso do serviço.
          </p>

          <h2>9. Encerramento</h2>
          <p>
            Você pode encerrar sua conta a qualquer momento. Consulte nossa{" "}
            <Link to="/privacidade" className="text-[#3457d5] font-semibold">Política de Privacidade</Link> e a{" "}
            <Link to="/exclusao-de-dados" className="text-[#3457d5] font-semibold">página de Exclusão de Dados</Link>.
          </p>

          <h2>10. Alterações destes termos</h2>
          <p>
            Podemos atualizar estes Termos periodicamente. A data de "última atualização" no topo indica a versão
            vigente.
          </p>

          <h2>11. Contato</h2>
          <p>
            Dúvidas sobre estes Termos? Fale conosco pelo e-mail{" "}
            <a href={`mailto:${EMAIL}`} className="text-[#3457d5] font-semibold">{EMAIL}</a>.
          </p>
        </section>

        <div className="mt-10 border-t border-slate-200 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-sm">
          <Link to="/" className="text-[#3457d5] font-semibold" data-testid="terms-home-link">← Voltar ao início</Link>
          <nav className="flex flex-wrap gap-x-4 gap-y-1 text-slate-500">
            <Link to="/termos" className="hover:text-[#3457d5]">Termos</Link>
            <Link to="/privacidade" className="hover:text-[#3457d5]">Privacidade</Link>
            <Link to="/exclusao-de-dados" className="hover:text-[#3457d5]">Exclusão de Dados</Link>
          </nav>
        </div>
      </main>
    </div>
  );
}
